import { Component, Vue, Prop } from "vue-property-decorator";
import template from "./rim-repair-roles.template.vue";
import { ROLES_LIST, UserRoles, IRoleItem } from "@/interfaces";

@Component({
  mixins: [template]
})
export default class RimRepairRolesComponent extends Vue {
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: [] }) selectedRoles!: UserRoles[];
  public rolesList = ROLES_LIST;

  roleName(role: UserRoles) {
    const r: IRoleItem | undefined = this.rolesList.find(r => r.value === role);
    return r ? r.text : "";
  }

  addRole(role: UserRoles) {
		this.selectedRoles.push(role);
  }

  removeRole(role: UserRoles) {
		var iof = this.selectedRoles.indexOf(role);
		this.selectedRoles.splice(iof, 1);
  }
}
